<div *ngIf="antibiotics?.length" class="antibioticos">
  <p-table [value]="antibiotics" [paginator]="false" [responsive]="true">
    <ng-template pTemplate="header">
      <tr>
        <th id="antibiotico-column">
          {{ "REQUEST_DATA.TEST.ANTIBIOTICO" | translate }}
        </th>
        <th
          *ngFor="let bacteriumName of bacteriumNames"
          class="bacterium-name"
          id="{{ bacteriumName }}-column"
        >
          {{ bacteriumName }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-antibiotic>
      <tr>
        <td>{{ antibiotic.methname }}</td>
        <td *ngFor="let item of bacteriumNames; index as i">
          {{ antibiotic["columna" + (i + 1)] }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="info">
    <p>
      {{ "REQUEST_DATA.TEST.ANTIBIOTICO_INFO" | translate }}
    </p>
  </div>
</div>
